import * as React from 'react';
import S from './Form.styles';
const FormSection = React.forwardRef(({ disabled, visible, title, content, children, ...props }, ref) => {
    return (React.createElement(S.Section, { ref: ref, disabled: disabled, "data-visible": visible, ...props },
        title && (React.createElement(S.Title, null,
            React.createElement("span", null, title))),
        content && React.createElement(S.Content, null, content),
        children));
});
FormSection.displayName = 'FormSection';
export default FormSection;
